import { render, staticRenderFns } from "./AccessGroupsForm.vue?vue&type=template&id=79da220f"
import script from "./AccessGroupsForm.vue?vue&type=script&lang=js"
export * from "./AccessGroupsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports